var React = require('react');

function Chevron (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.573 6.454L1.898.224A.845.845 0 001.318 0c-.22 0-.426.08-.58.224L.245.682a.731.731 0 000 1.083L5.85 6.997.24 12.235a.736.736 0 00-.24.541c0 .205.085.397.24.542l.491.458c.155.145.36.224.58.224.22 0 .426-.08.58-.224l6.682-6.235a.736.736 0 000-1.087z"}));
}

Chevron.defaultProps = {"fill":"#FFF","width":"10","height":"14","viewBox":"-1 0 10 14"};

module.exports = Chevron;

Chevron.default = Chevron;
